import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { ExternalLink, Calendar, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';

const MoreInformationPage = () => {
  return (
    <div className="p-6 md:p-12 lg:p-16" data-testid="more-information-page">
      <div className="max-w-4xl">
        <h1 className="font-heading text-4xl md:text-5xl font-bold text-gray-900 mb-6">
          More Information
        </h1>

        {/* External Links */}
        <section className="mb-10" data-testid="external-links-section">
          <p className="text-lg text-gray-700 leading-relaxed mb-6">
            Further information on Freemasonry in Scotland is available from the Grand Lodge of Scotland's 
            website. For information on Freemasonry in Edinburgh, consult the website of the Provincial 
            Grand Lodge of Edinburgh.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
            <a
              href="http://www.grandlodgescotland.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="block"
              data-testid="grand-lodge-link"
            >
              <Card className="border-gray-100 hover:shadow-md hover:border-emerald-200 transition-all h-full">
                <CardContent className="p-5">
                  <div className="flex items-start justify-between">
                    <div>
                      <h3 className="font-medium text-gray-900 mb-2">Grand Lodge of Scotland</h3>
                      <p className="text-sm text-gray-500">www.grandlodgescotland.com</p>
                    </div>
                    <ExternalLink className="h-5 w-5 text-gray-400" />
                  </div>
                </CardContent>
              </Card>
            </a>

            <a
              href="http://www.pgle.org/"
              target="_blank"
              rel="noopener noreferrer"
              className="block"
              data-testid="pgle-link"
            >
              <Card className="border-gray-100 hover:shadow-md hover:border-emerald-200 transition-all h-full">
                <CardContent className="p-5">
                  <div className="flex items-start justify-between">
                    <div>
                      <h3 className="font-medium text-gray-900 mb-2">Provincial Grand Lodge of Edinburgh</h3>
                      <p className="text-sm text-gray-500">www.pgle.org</p>
                    </div>
                    <ExternalLink className="h-5 w-5 text-gray-400" />
                  </div>
                </CardContent>
              </Card>
            </a>
          </div>
        </section>

        {/* How to Join */}
        <section className="mb-10" data-testid="how-to-join-section">
          <h2 className="font-heading text-2xl font-semibold text-gray-900 mb-4">
            Interested in Joining?
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed mb-6">
            If you are interested in joining Freemasonry and meet the entry qualifications, contact our 
            Lodge Secretary, who will be able to provide further details and an application form. Or why 
            not arrange to attend one of the lunches following one of our regular meeting dates?
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Link to="/contact" data-testid="contact-card-link">
              <Card className="border-gray-100 hover:shadow-md hover:border-emerald-200 transition-all h-full">
                <CardContent className="p-5">
                  <div className="flex items-center gap-4">
                    <div className="h-12 w-12 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0">
                      <Mail className="h-6 w-6 text-emerald-600" />
                    </div>
                    <div>
                      <h3 className="font-medium text-gray-900">Contact Lodge Secretary</h3>
                      <p className="text-sm text-gray-500">Send us a message</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </Link>

            <Link to="/meetings" data-testid="meetings-card-link">
              <Card className="border-gray-100 hover:shadow-md hover:border-emerald-200 transition-all h-full">
                <CardContent className="p-5">
                  <div className="flex items-center gap-4">
                    <div className="h-12 w-12 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0">
                      <Calendar className="h-6 w-6 text-emerald-600" />
                    </div>
                    <div>
                      <h3 className="font-medium text-gray-900">View Meeting Dates</h3>
                      <p className="text-sm text-gray-500">Plan your visit</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </Link>
          </div>
        </section>

        {/* Qualifications Reminder */}
        <section data-testid="qualifications-reminder">
          <Card className="bg-gradient-to-br from-gray-50 to-white border-gray-100">
            <CardContent className="p-6 md:p-8">
              <h3 className="font-heading text-xl font-semibold text-gray-900 mb-3">
                Entry Qualifications
              </h3>
              <p className="text-gray-700 mb-4">
                Before applying, please review our entry qualifications to ensure you meet the requirements 
                for membership.
              </p>
              <Link
                to="/university-lodge-scheme/qualifications"
                className="inline-flex items-center text-emerald-600 hover:text-emerald-700 font-medium transition-colors"
                data-testid="qualifications-link"
              >
                View Qualifications
                <ExternalLink className="h-4 w-4 ml-2" />
              </Link>
            </CardContent>
          </Card>
        </section>
      </div>
    </div>
  );
};

export default MoreInformationPage;
